import { z } from "zod";

const envSchema = z.object({
  API_URL: z.string(),
  ENVIRONMENT: z
    .enum(["development", "production", "testing"])
    .default("production"),
  APP_ID: z.string(),
  GRAPH_API_VERSION: z.string(),
  CONFIGURATION_ID: z.string(),
  FEATURE_TYPE: z.string(),
  // Chave estática que protege o endpoint de solicitação de código OTP.
  AUTH_OPT_KEY: z.string().default(""),
});

const env = envSchema.parse({
  API_URL: import.meta.env.VITE_API_URL,
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
  APP_ID: import.meta.env.VITE_APP_ID,
  GRAPH_API_VERSION: import.meta.env.VITE_GRAPH_API_VERSION,
  CONFIGURATION_ID: import.meta.env.VITE_CONFIGURATION_ID,
  FEATURE_TYPE: import.meta.env.VITE_FEATURE_TYPE,
  AUTH_OPT_KEY: import.meta.env.AUTH_OPT_KEY,
});

export { env };
